export default __webpack_public_path__ + "static/media/financiero_31-12-2023.0051590e.pdf";